export enum V3MembershipPlanKey {
  REGULAR = 'regular',
  CASUAL = 'casual',
  MAKUAKE_TRIAL = 'makuake_trial',
  MAKUAKE_STANDARD = 'makuake_standard',
  SPRING_2020 = 'spring_2020',
  GOTO_2020 = 'goto_2020',
  PLANNER = 'planner',
}

export type MembershipPlanId = number
export type MembershipItemId = number

export type ISODateTime = string

export enum MembershipPlanGroupKey {
  LIKES = 'likes',
  MULTICREATOR = 'multicreator',
  BEAUTY = 'beauty',
  MONEY = 'money',
}

export enum MembershipPlanKey {
  CASUAL = 'casual',
  REGULAR = 'regular',
}

export enum CampaignType {
  FIRST_PAYMENT = 'first_payment',
  V2_MEMBER = 'v2_member',
}

export type FirstPaymentCampaignSpec = {
  type: CampaignType.FIRST_PAYMENT
  name: string
  description: string
  amount: number
  expires_at: ISODateTime
}

export type V2MemberCampaignSpec = {
  type: CampaignType.V2_MEMBER
  free_trial_months: number
  available_tickets: number
  expires_at: ISODateTime
  payment_starts_at: ISODateTime
}

export type CampaignSpec = V2MemberCampaignSpec | FirstPaymentCampaignSpec

export type MembershipPlanIndexView = {
  id: MembershipPlanId
  key: MembershipPlanKey
  name: string
  items: MembershipItemIndexView[]
  discount_campaigns: CampaignSpec[]
  lesson_deactivation: boolean
}

export type SuccinctCampaign = {
  name: string
  discount: number
}

export type MembershipItemIndexView = {
  id: MembershipItemId
  name: string
  total_price: number
  price: number
  price_with_tax: number
  base_price: number
  discount: number
  tax: number
  duration_month: number
  discount_campaigns: SuccinctCampaign[]
  membership_plan_id: MembershipPlanId
  membership_plan: MembershipPlanIndexView
  membership_plan_key: V3MembershipPlanKey
}
